{
    "Para1": "Select a dashboard layout from the options below:",
    "NAME": "DashboardDisplaySettings",
    "DashboardDisplaySettings_SectionHeader": "Display Settings"
}